/**
 * envirolink.ai cutover (Chris 2026-11-03): the old Railway web host 301s to
 * www.envirolink.ai at nginx, but a phone with the icon pinned to the old
 * origin boots from its service-worker cache and never reaches nginx. So,
 * before anything mounts: on the old host only, drop the service workers
 * and caches, then move to www with the same path. On any other host this
 * does nothing.
 */
export const OLD_WEB_HOST = 'envirolinkweb-production.up.railway.app';
export const NEW_WEB_ORIGIN = 'https://www.envirolink.ai';

type Loc = Pick<Location, 'hostname' | 'pathname' | 'search' | 'hash'>;

export function newUrlFor(loc: Loc): string | null {
  if (loc.hostname !== OLD_WEB_HOST) return null;
  return `${NEW_WEB_ORIGIN}${loc.pathname}${loc.search}${loc.hash}`;
}

export async function migrateFromOldHost(
  loc: Loc = window.location,
  go: (url: string) => void = (url) => window.location.replace(url),
  sw:
    | Pick<ServiceWorkerContainer, 'getRegistrations'>
    | undefined = navigator.serviceWorker,
  cacheStore:
    | Pick<CacheStorage, 'keys' | 'delete'>
    | undefined = typeof caches === 'undefined' ? undefined : caches
): Promise<boolean> {
  const target = newUrlFor(loc);
  if (!target) return false;
  try {
    const regs = sw ? await sw.getRegistrations() : [];
    await Promise.all(regs.map((r) => r.unregister()));
    const keys = cacheStore ? await cacheStore.keys() : [];
    await Promise.all(keys.map((k) => cacheStore!.delete(k)));
  } catch {
    // A refused cache is no reason to stay on the old host.
  }
  go(target);
  return true;
}
